/**
 * Studio Preview — Shared UI primitives
 * -------------------------------------
 * Small building blocks reused across every sandbox page:
 *   - <Card>       :  white surface with 0.5px border + subtle shadow.
 *   - <PageHeader> :  H1 title + optional subtitle + optional right-side action.
 *
 * Kept intentionally minimal — do NOT add domain-specific logic here.
 */
import React from "react";

export function Card({ children, className = "" }) {
  return (
    <div className={`bg-white rounded-lg border border-slate-200 shadow-sm ${className}`}>
      {children}
    </div>
  );
}

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6 flex-wrap">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">{title}</h1>
        {subtitle && <p className="mt-1 text-[13px] text-slate-500">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
